/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentActionsAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of content actions available
 */
define([], () => {
	class DeleteActionAPI {

		/**
		 * @function DeleteActionAPI#setOnBeforeDeleteCallback
		 * @deprecated
		 * @description Sets a callback to be called before a widget is deleted.
		 * @param {callback} function to be called before delete is applied.
		 */
		setOnBeforeDeleteCallback( /* callback */ ) {}

	}

	return DeleteActionAPI;
});